// @flow
import React from 'react'

import styled from 'styled-components'

import { SmallBodyCopy, Label, Caption } from 'components/Text'
import { Caption2 } from 'ds/Text'
import getSentimentColors from 'utils/getSentimentColors'
import colors from 'theme/colors'

const Theme = colors.light

// type Size = 'micro' | 'small' | 'big';
// type Style = 'outline' | 'regular' | 'regularNoBorder';
//
// type OwnProps = {
//   text?: string,
//   sentiment:
//     | 'positive'
//     | 'negative'
//     | 'attentive'
//     | 'neutral'
//     | 'important'
//     // following are RARELY USED !
//     | 'regular'
//     | 'inverted',
//   /**
//    * @default small
//    */
//   size?: Size,
//   styl?: Style,
//   textStyle?: any,
//
//   block?: boolean,
// };

const Root = styled.span`
	display: inline-block;
	box-shadow: none !important;
	white-space: nowrap;
	flex-grow: 0;
	flex-shrink: 0;
	${props => (!props.block ? `display: inline-block;` : `display: block;`)};

	${props => props.size === 'big' && `padding: 4px 16px;`};
	${props => props.size === 'small' && `padding: 1px 8px;`};
	${props => props.size === 'micro' && `padding: 0px 4px;`};

	border-radius: 6px;
	${props =>
		props.styl === 'outline'
			? `border: 1px solid ${getSentimentColors(props.sentiment).fg};`
			: `border: ${props.styl === 'regularNoBorder' ? '0px' : '1px'} solid ${getSentimentColors(props.sentiment).bg};`};
	${props =>
		props.styl === 'outline'
			? `background-color: ${Theme.background}`
			: `background-color: ${getSentimentColors(props.sentiment).bg}`};

	${props =>
		props.onClick &&
		`
    cursor: pointer;
    
    &:hover {
      opacity: 0.8
    }
    `};
	&,
	& * {
		white-space: nowrap;
	}
`

export default function Tag(props) {
	const size = props.size ?? 'small'

	const Component = {
		big: SmallBodyCopy,
		small: Caption2,
		micro: Caption,
	}[size]

	const top = {
		big: '0px',
		small: '-1px',
		micro: '0px',
	}[size]

	return (
		<Root {...props} size={size}>
			<Component
				sentiment={props.sentiment}
				$color={getSentimentColors(props.sentiment).fg}
				rawColor={getSentimentColors(props.sentiment).fg}
				weight={400}
			>
				{props.text && (
					<span
						style={{
							position: 'relative',
							top,
						}}
					>
						{props.text}
					</span>
				)}
			</Component>
		</Root>
	)
}
